// What a contract's status is *called*, everywhere it is shown.
//
// 'pending_edit' is one stored status but two different situations, and users
// read them very differently: a contract can be back with its initiator
// because an approver asked for changes ("Geri Gönderildi"), or because a
// control step found it unsuitable ("Uygun Görülmedi"). approvalState is what
// separates them. Lists, task tables, the contract page and their exports all
// go through here so a contract never reads as one thing on one screen and
// another thing on the next.
//
// Every other status maps to itself — this is only about naming, never about
// the value stored on the contract.
export const contractStatusKey = (contract) => {
  const status = typeof contract === 'string' ? contract : contract?.status;
  if (!status) return '';
  if (status !== 'pending_edit') return status;
  return (typeof contract === 'object' && contract?.approvalState === 'rejected')
    ? 'not_suitable'
    : 'sent_back';
};

// The label itself. `t` is the caller's translation function; unknown statuses
// fall back to their humanised value rather than showing a raw i18n key.
export const contractStatusLabel = (contract, t, fallback = '') => {
  const key = contractStatusKey(contract);
  if (!key) return fallback;
  const translated = t(`contracts.status.${key}`, { defaultValue: '' });
  if (translated && translated !== `contracts.status.${key}`) return translated;
  return key.replace(/_/g, ' ');
};
